import { render, staticRenderFns } from "./hierarchy-year-node.vue?vue&type=template&id=887629ee&scoped=true&"
import script from "./hierarchy-year-node.vue?vue&type=script&lang=ts&"
export * from "./hierarchy-year-node.vue?vue&type=script&lang=ts&"
import style0 from "./hierarchy-year-node.vue?vue&type=style&index=0&id=887629ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "887629ee",
  null
  
)

export default component.exports